import { Item } from "./item";
export class ProjectData {
    name;
    description;
    deadline;
    priority;
    notes;
    completed;
    constructor(name, description, deadline, priority, notes) {
        this.name = name;
        this.description = description;
        this.deadline = deadline;
        this.priority = priority;
        this.notes = notes;
        this.completed = false;
    }
}
export class Project extends Item {
    position;
    constructor(name, description, deadline, priority, notes, position) {
        super(name, description, deadline, priority, notes);
        this.position = position || -1;
    }
    static fromFormData(data) {
        return new Project(data.get("name"), data.get("description"), new Date(data.get("deadline")), Number(data.get("priority")), data.get("notes"), Number(data.get("position")) || undefined);
    }
    static toJSON(tasks) {
        return JSON.stringify(tasks.map((t) => ({
            id: t.id,
            createdAt: t.createdAt,
            name: t.name,
            description: t.description,
            deadline: t.deadline,
            priority: t.priority,
            notes: t.notes,
            position: t.position,
            completed: t.completed,
        })));
    }
    static fromJSON(json) {
        const data = JSON.parse(json);
        return data.map((d) => {
            const { name, description, deadline, priority, notes, position } = d;
            const t = new Project(name, description, new Date(deadline), priority, notes, position);
            t.id = d.id;
            t.createdAt = new Date(d.createdAt);
            t.completed = d.completed;
            return t;
        });
    }
}
